<template>
  <div id="contents">
    <div class="recruit_galaxy_award" >
      <div class="recruit_galaxy_award_main">
        <div class="title_area">
          <h2 class="title"> #1年目でギャラクシー賞受賞！！</h2>
        </div>
        <div @click="close" class="close_icon">
          <img src="../assets/img/common/recruit_2021/close_icon.svg" alt="close" />
        </div>
        <div class="kv">
          <div class="kv_inner">
            <div class="text">
              <p class="ja">梅澤慶光</p>
              <p class="en">Yoshimitsu Umezawa</p>
              <p class="desc">亜細亜大学 経済学部を卒業後、2019年に入社。第2制作局 第2制作部。<br>「羽鳥慎一 モーニングショー」を経て、自身で企画したBS朝日「最後のホームルーム（2020年2月OA）」を制作。テレビ、映画、アイドルなどのエンタメを楽しむことが趣味。入社1年目で実現した企画「最後のホームルーム　同窓会をプロデュース」は第57回ギャラクシー賞奨励賞受賞。第36回ATPテレビグランプリ最優秀新人賞受賞。<br>現在の担当番組は、テレビ朝日「ノブナカなんなん?」、テレビ東京特番「ツタの家。」。</p>
            </div>
            <p class="kv_bg"><img src="../assets/img/common/recruit_2024/galaxy_award/kv.png" alt="" width="1000"></p>
          </div>
        </div>
        <div class="article">
          <div class="article_inner">
            <ul class="article_list">
              <li class="article_list_item">
                <h3 class="article_list_item_ttl">ギャラクシー賞が取れる！ といつ手応えを感じましたか？</h3>
                <div class="content">
                  <div class="image">
                    <p class="img"><img src="../assets/img/common/recruit_2024/galaxy_award/article_01.png" alt="" width="434"></p>
                  </div>
                  <div class="text">
                    <p class="ttl">取材してすぐ、<br>「イケるかも！」と感じた。</p>
                    <div class="desc">
                      <p>ギャラクシー賞を受賞した「最後のホームルーム」は、閉校する小学校を舞台に、同窓会をする特番企画。<br>この番組を制作するにあたり、協力してくださる卒業生を探し出したところ、「ユニークで型破りな授業をしていた、名物先生に会いたい」と話されていたんです。<br>そこで栃木県まで向かい、先生を見つけてお話を伺うと、出てくるエピソードがいいものばかり。ドラマチックな物語や児童への愛情、人生の中での後悔など、喜怒哀楽が混ざりあったご経験の数々をお聞きできました。そのときに「すごい人を見つけた！」「これはイケるかも！」と心の中でガッツポーズをした記憶があります。それと同時に、大変な経験をされてきた先生の物語を番組として編集することに対し、責任とプレッシャーも感じました。</p>
                    </div>
                  </div>
                </div>
              </li>
              <li class="article_list_item">
                <h3 class="article_list_item_ttl">制作中、大変だったことは？</h3>
                <div class="content">
                  <div class="image">
                    <p class="img"><img src="../assets/img/common/recruit_2024/galaxy_award/article_02.png" alt="" width="434"></p>
                  </div>
                  <div class="text">
                    <p class="ttl">良くも悪くも、1年目でも、<br>私をディレクターとして<br>尊重してくれること。</p>
                    <div class="desc">
                      <p>「最後のホームルーム」では私がディレクターなので当然、自分で台本も制作しました。実はロケの台本を書くのはこの特番が初めて。先生が持つ「クラスで起こった忘れられない事件」を卒業生に伝えるパートでは、どう演出すればドラマチックに伝えられるのか、ずいぶん悩みました。<br>19時に台本を書き始めて、結局仕上がったのは次の日の5時。9時間かけて書き上げ、先輩にチェックしていただいたのは、結婚式で行われる「メモリプレイ」という目の前で俳優さんが当時を再現する方法を使った台本でした。先輩が「面白いじゃん」と言ってくださったときはホッとしましたね。当日は現場で涙を流す方もいて、ドラマチックなシーンを撮影することができました。</p>
                      <p>今思えば先輩を朝まで待たせてしまい、失礼なことをしたと思いますが、黙って待ってくださる姿勢を見て私も「頑張ろう」と思い、大変な時期も乗り越えられました。</p>
                    </div>
                  </div>
                </div>
              </li>
              <li class="article_list_item">
                <h3 class="article_list_item_ttl">ギャラクシー賞を受賞したときの気持ちは？</h3>
                <div class="content">
                  <div class="point">
                    <p class="ttl">恩師から教わった、<br>制作時の3つのポイント</p>
                    <ol class="point_list">
                      <li>
                        <p class="num">❶</p>
                        <p class="text">必要な言葉、必要な画トップ3を決めて、<br>それだけは必ずロケで撮ること</p>
                      </li>
                      <li>
                        <p class="num">❷</p>
                        <p class="text">出演者のあらゆる喜怒哀楽を想定して、<br>周到に準備すること</p>
                      </li>
                      <li>
                        <p class="num">❸</p>
                        <p class="text">自分だけの色（オリジナリティ）がある<br>VTR になっているか確認すること</p>
                      </li>
                    </ol>
                  </div>
                  <div class="text">
                    <p class="ttl">「ギャラクシー賞を取る！」と<br>公言していたので、受賞したときは<br>正直ホッとしました。</p>
                    <div class="desc">
                      <p>「ギャラクシー賞を取る！」という目標は、入社早々から公言していました。自分にプレッシャーをかけて追い込みたかったんです。ですので実際に受賞できたときは、嬉しさもありましたが、正直ホッとしました。もしも受賞できなかったら、ただ調子に乗った若手になっていたので…。</p>
                      <p>私が受賞できたのは、基本的な姿勢を教えてくださった恩師や、「やりたいことは全部やれ」とアドバイスをくださった上司や局長のおかげでもあります。ディレクターとして何を選択したら良いのか悩む私に「発案者なのだからやりたいようにやりなさい」と言っていただいたおかげで、周囲の意見を聞くだけでなく、自分の色を出せたと思っています。</p>
                    </div>
                  </div>
                </div>
              </li>
              <li class="article_list_item">
                <h3 class="article_list_item_ttl">いい企画の条件とは？</h3>
                <div class="content">
                  <div class="image">
                    <p class="img"><img src="../assets/img/common/recruit_2024/galaxy_award/article_03.png" alt="" width="434"></p>
                  </div>
                  <div class="text">
                    <p class="ttl">1つでもオリジナリティがある。<br>それがいい企画だと思います。</p>
                    <div class="desc">
                      <p>毎週のように各局でトライアル企画が放送されている今、全てが新しい発想で作られた番組を開発するのはほぼ不可能だと思っています。例えば、私が企画し、テレビ東京で放送された「ツタの家。」は“誰もが経験したことがある普遍的なモノで潜在意識を突く企画”の形に、「ツタの家ってよく見かけるし、どんな人が住んでいるんだろう？」と私が生活するなかで生まれた、ふとした疑問というオリジナリティを足したもの。切り口が新しい、タイトルが秀逸など、何か1つだけでもいいのでオリジナリティを出すと、いい企画になると思います。</p>
                    </div>
                  </div>
                </div>
              </li>
              <li class="article_list_item">
                <h3 class="article_list_item_ttl">学生へのメッセージをお願いします。</h3>
                <div class="content">
                  <div class="image">
                    <p class="img"><img src="../assets/img/common/recruit_2024/galaxy_award/article_04.png" alt="" width="434"></p>
                  </div>
                  <div class="text">
                    <p class="ttl">就活って大変ですよね。<br>私はもう2度とやりたくないです！</p>
                    <div class="desc">
                      <p>私は最初、どうしても「テレビ局」に入りたかったのですが、1年目は全滅。2年目は制作会社まで視野を広げて、ようやくテレビ朝日映像とのご縁が見つかりました。今思えば、2年目はネームバリューやお給料より、私にとっては「本当にやりたい仕事なのか？」「10・20年後にどんな人になっていたいのか？」を突き詰めて就活したから、いい結果に結びついたのだと思います。</p>
                      <p>テレビ朝日映像は1年目でも各局の新規番組企画に応募できる環境があり、「最後のホームルーム」もBS朝日が各社から集めた企画のなかで採用されたもの。募集がなくても、上司に相談すればテレビ局に企画を提案することもできます。真面目に努力して、したたかに戦略を練って、何よりやる気さえあれば、若手にもチャンスがある会社です。<br>大きな野望を持った、学生の皆さんといつか一緒に働けることを楽しみにしています！</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="program">
          <div class="program_inner">
            <h3 class="program_ttl">「最後のホームルーム　同窓会をプロデュース」</h3>
            <p class="content_ttl">番組概要</p>
            <div class="content">
              <div class="left">
                <p class="img"><img src="../assets/img/common/recruit_2024/galaxy_award/program.png" alt="" width="434"></p>
              </div>
              <div class="right">
                <p>明治に開校した歴史を持つ栃木県のある小学校が閉校するのを機に、番組が卒業生の1人に「同窓会をプロデュースさせてほしい」と提案。卒業生は「名物先生に会いたい」、「地元を盛り上げたい」そんな思いを胸に当時のクラスメイトに連絡し、20人程度が同窓会に参加することに。しかし、肝心の名物先生が当日参加するのかまではわからないまま、29年越しに再びクラスメイトが集まる日を迎えた。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_galaxy_award',
  data() {
    return {
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'post_type'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  .recruit_galaxy_award
    &_main
      width: 1000px
      margin: 161px auto 150px
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -49px
        left: 55px
        z-index: 2
      .title
        @include recruit_font(41px, 64px, .176em)
        color: #fff
        background: #E0AA17
        padding: 5px 19px 9px 18px
        display: table
      .close_icon
        position: absolute
        right: 0px
        top: -65px
        img
          width: 40px
          height: 40px
      .kv
        margin-bottom: 52px
        &_inner
          position: relative
          .text
            position: absolute
            left: 67px
            bottom: 40px
            display: flex
            flex-direction: column
            align-items: flex-start
            .ja,.en
              display: inline-block
              font-weight: bold
              color: #fff
              background: #E0AA17
            .ja
              padding: 9px 5px 8px 6px
              @include recruit_font(32px, 1, .176em)
            .en
              margin-bottom: 13px
              padding: 5px 8px 7px 6px
              @include recruit_font(18px, 1, 0.05em)
            .desc
              width: 427px
              font-family: 'Noto Sans JP', sans-serif
              @include recruit_font(10px, 17px, 0.05em)
              color: #fff
      .article
        margin-bottom: 101px
        &_inner
          .article_list
            &_item
              position: relative
              margin-bottom: 101px
              padding-top: 125px
              &:nth-child(2n)
                .content
                  flex-direction: row-reverse
              &:last-child
                margin-bottom: 0px
              &_ttl
                position: absolute
                top: 0
                left: -26px
                padding: 19px 21px 18px 63px
                background: #E0AA17
                @include recruit_font(29px, 1, 0.12em)
                color: #fff
              .content
                display: flex
                justify-content: space-between
                align-items: flex-start
                width: 877px
                margin: 0 auto
                .point
                  width: 410px
                  margin-top: 43px
                  padding: 31px 0 43px
                  background: #E0AA17
                  .ttl
                    margin-bottom: 30px
                    font-family: 'Noto Sans JP', sans-serif
                    @include recruit_font(18px, 28px, 0.196em)
                    text-align: center
                    color: #fff
                  .point_list
                    padding-left: 46px
                    list-style-type: none
                    li
                      display: flex
                      align-items: center
                      margin-bottom: 10px
                      &:last-child
                        margin-bottom: 0px
                      .num
                        margin-right: 10px
                        @include recruit_font(18px, 1, 0.196em)
                        color: #fff
                      .text
                        @include recruit_font(14px, 24px, 0.14em)
                .text
                  width: 412px
                  padding-top: 2px
                  .ttl
                    margin-bottom: 18px
                    @include recruit_font(21px, 28px, 0.136em)
                    color: #E0AA17
                  .desc
                    p
                      margin-bottom: 25px
                      @include recruit_font(12px, 25px, 0.18em)
                      &:last-child
                        margin-bottom: 0px

      .program
        background: #E0AA17
        padding: 50px 0 48px
        &_inner
          width: 877px
          margin: 0 auto
          .program_ttl
            width: 730px
            margin: 0 auto 23px
            padding: 18px 0
            background: #fff
            @include recruit_font(29px, 1, 0.12em)
            text-align: center
            color: #E0AA17
          .content_ttl
            margin: 0 auto 44px
            @include recruit_font(21px, 1, 0.136em)
            text-align: center
            color: #fff
          .content
            display: flex
            justify-content: space-between
            align-items: center
            .right
              width: 414px
              p
                @include recruit_font(12px, 25px, 0.18em)

</style>



// WEBPACK FOOTER //
// src/components/recruit_galaxy_award.vue